// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e64f2ed5","417":"37ca80d5","466":"f8c3e104","703":"c165c324"}[chunkId] + ".chunk.js";
};